module.exports = __webpack_public_path__ + "static/media/28.e9818a97.jpeg";